import { render, staticRenderFns } from "./ShippingFeeItems.vue?vue&type=template&id=9fed96b4&"
import script from "./ShippingFeeItems.vue?vue&type=script&lang=ts&"
export * from "./ShippingFeeItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports